<template>
	<!--物联机柜弹框表格-->
	<el-table
		height="300"
		stripe
		border
		:data="tableData"
		:cell-style="cellStyle"
		style="width: 100%">
			<el-table-column
				prop="cabinet_name"				
				label="机柜">
			</el-table-column>
			<el-table-column
				prop="temperature"
				label="温度（℃）"					
				:formatter="getValue1">
			</el-table-column>		
			<el-table-column
				prop="humidity"					
				label="湿度（%）"
				:formatter="getValue1">
			</el-table-column>
			<el-table-column
				prop="load"
				label="负载百分比">
			</el-table-column>
			<el-table-column
				prop="fan"
				label="风机"
				:formatter="getValue2">
			</el-table-column>		
			<el-table-column
				prop="pdu_one_load"
				width="120"
				label="PDU1负载（%）">
			</el-table-column>	
			<el-table-column
				prop="pdu_one_power"
				width="130"
				label="PDU1功率（W）">
			</el-table-column>	
			<el-table-column
				width="120"
				prop="pdu_two_load"
				label="PDU2负载（%）">
			</el-table-column>	
			<el-table-column
				width="130"
				prop="pdu_two_power"
				label="PDU2功率（W）">
			</el-table-column>	
			
		</el-table>
</template>
<script>

export default {
  name: 'app',
  data(){
    return {
		tableData: []
    }
  },
  mounted(){
	this.$nextTick(()=>{
		this.getTableData();			
	})
  },
  methods: {
	  // 物联机柜弹框
		getTableData(){
			let valiCodeParams={
				uid:this.getCookie('uid'),
				token:this.getCookie('token'),
				time:Date.parse( new Date()),
				terminalId:4
			};
			
			this.sign2(valiCodeParams);
			this.$ajax.post(this.$store.state.domain2+"/admin/Workbench/cabinet_list",this.$qs.stringify(valiCodeParams),{
				emulateJSON: true
			}).then(res=>{
				if(res.data.code=="200"){
					this.tableData = res.data.data || [];
					// this.$message.success(res.data.msg);
				}else if(res.data.code==10008){
					this.isLogouting = true;
					this.delCookie('username');
					this.$router.push('/login/');
					this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
				}else{
					this.$message.error(res.data.msg);
				}
			});
		},

	  // 处理返回的温湿度数据-表格
		getValue1(row, column){
	
		       return row.temperature.value;					
		},
		// 处理返回的风扇数据-表格
		getValue2(row){
			if(row.fan.fan_control_temperature){
				return row.fan.fan_operation_mode.value;
			}else{
				return ""
			}
			
		},
	// 修改单元格样式 温湿度 1红色 2橙色 3正常
	cellStyle(row, column, rowIndex, columnIndex){				
		if(row.columnIndex==1){
			if(row.row.temperature && row.row.temperature.alarm_type){
				if(row.row.temperature.alarm_type==1){
					return "color:red;"
				}else if(row.row.temperature.alarm_type==2){
					return "color:orange;"
				}
				return ""
			}
		}else if(row.columnIndex==2){
			if(row.row.humidity && row.row.humidity.alarm_type){
				if(row.row.humidity.alarm_type==1){
					return "color:red;"
				}else if(row.row.humidity.alarm_type==2){
					return "color:orange;"
				}
				return ""
			}
		}else{
			return ""
		}
	},
	
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/comss/tableDialog.vue